"use client"

import React, { useEffect, useState } from "react"
import { useSearchParams } from "next/navigation"

const UTM_SOURCE_KEY = "utm_source"
const UTM_MEDIUM_KEY = "utm_medium"

const TRAFFIC_SOURCE_KEY = "traffic_source"

const EXPIRATION_RANGE = 86400000

export type TrafficSourceItem = {
  utmSource: string | null
  utmMedium: string | null
  timestamp: number
}

export default function TrafficSourceProvider() {
  const params = useSearchParams()
  const utmSource = params.get(UTM_SOURCE_KEY)
  const utmMedium = params.get(UTM_MEDIUM_KEY)

  useEffect(() => {
    storeTrafficSource(utmSource, utmMedium)
  }, [utmSource, utmMedium])

  return <></>
}

export function useTrafficSource(): TrafficSourceItem {
  const [sourceItem, setSourceItem] = useState<TrafficSourceItem>({
    utmSource: null,
    utmMedium: null,
    timestamp: 0,
  })

  useEffect(() => {
    const trafficSource = retrieveTrafficSource()
    if (trafficSource) {
      setSourceItem(trafficSource)
    }
  }, [])

  return sourceItem
}

function storeTrafficSource(source: string | null, medium: string | null) {
  if (!isSourceExpired()) return
  const sourceItem = JSON.stringify({
    utmSource: source,
    utmMedium: medium,
    timestamp: new Date().getTime(),
  })
  localStorage.setItem(TRAFFIC_SOURCE_KEY, sourceItem)
}

function isSourceExpired(): boolean {
  const source = retrieveTrafficSource()
  if (!source) return true
  const now = new Date().getTime()
  return now - source.timestamp >= EXPIRATION_RANGE
}

function retrieveTrafficSource(): TrafficSourceItem | null {
  if(!localStorage) return null
  const rawSource = localStorage.getItem(TRAFFIC_SOURCE_KEY)
  if (!rawSource) return null
  return JSON.parse(rawSource)
}

function removeTrafficSource() {
  localStorage.removeItem(TRAFFIC_SOURCE_KEY)
}

export { retrieveTrafficSource, removeTrafficSource }